<template>
	<div class="wrapper">
		<AppHeader />
        <AppSidebar />
		<div class="content-wrapper">
			<div class="row" v-if="user">
				<div v-if="user.data.is_officer" class="col-md-12">
					<router-view />
				</div>
				<div v-else :class="public_user_classes">
					<router-view />
				</div>
			</div>
		</div>
		<loading :active.sync="$store.state.loading.status" />
	</div>
</template>

<script>
import AppHeader from "@/views/layouts/partials/Header.vue";
import AppSidebar from "@/views/layouts/partials/Sidebar.vue";
import { mapState } from "vuex";
export default {
	components: {
		AppHeader,
		AppSidebar
	},
	computed:{
		...mapState("user", ["user"]),
	},
  data(){
    return {
      public_user_classes: ""
    }
  },
  created() {
    window.addEventListener("resize", this.sizeEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.sizeEventHandler);
  },
  mounted() {
    this.sizeEventHandler();
  },
  methods:{
    sizeEventHandler() {
      let current_size = window.innerWidth;
      switch (true){
        case current_size <= 1200:
          this.public_user_classes = "col-md-12";
          break;
        case current_size <= 1600:
          this.public_user_classes = "col-md-10 offset-md-1";
          break;
        default:
          this.public_user_classes = "col-md-10 offset-md-1 col-lg-8 offset-lg-2";
          break;
      }
    }
  }
};
</script>